import { useMemo } from "react";
import { useSelector } from "react-redux";
import { ErrorText, useHasCredit } from "../../../../components/billing";
import { AppStore } from "../../../../store";
import { AuthDTO } from "../../../../store/auth/models/dto";
import { useFetchable } from "../../../../store/common/fetchable";
import {
  Fetchable,
  isFetchableSuccess,
} from "../../../../store/common/fetchable/helpers";
import { Users } from "../../../../store/users/reducer";
import { getOption } from "../../../../utils/utils";
import { CTA } from "../../../profile/base";

export const useNewIndividualKycCTA = () => {
  const currentUser = useFetchable(Users.current);
  const currentAuth = useSelector<
    AppStore,
    Fetchable<AuthDTO.Responses.Login.T>
  >((store) => store.auth.login);

  const hasCredit = useHasCredit("KYC");

  const isAdmin = useMemo(
    () =>
      isFetchableSuccess(currentAuth) &&
      currentAuth.data.accessToken.roles.includes("ROLE_ADMIN"),
    [currentAuth]
  );

  const isMerchant = useMemo(
    () =>
      isFetchableSuccess(currentAuth) &&
      currentAuth.data.accessToken.roles.includes("ROLE_MERCHANT"),
    [currentAuth]
  );

  return useMemo(
    () =>
      getOption(currentUser).map((curr) => {
        if (!hasCredit && !isAdmin) {
          return (
            <>
              <CTA disabled>Verify this User</CTA>
              <ErrorText>Please Top Up your Account</ErrorText>
            </>
          );
        }
        if (curr.kycStatus === "VERIFIED" || isAdmin || isMerchant) {
          return <CTA>Verify this User</CTA>;
        }
        return (
          <>
            <CTA disabled>Verify this User</CTA>
            <ErrorText>
              You cannot perform this action because your KYC status is not yet
              verified.
            </ErrorText>
          </>
        );
      }),
    [hasCredit, currentUser, isAdmin]
  );
};
